import React from 'react'

import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog'

const RemoveTagModal = ({ data = {}, onSubmit = () => {}, onClose = () => {} }) => (
    <ConfirmationDialog
        onClose={() => onClose()}
        onAction={async () => onSubmit(data.id)}
        successText="Tag removed successfully!"
        headText="Please, confirm"
        noteText={`Are you sure you want to remove this tag?`}
        actionVariant="danger"
        actionText="Remove"
        cancelText="Cancel"
    />
)

export default RemoveTagModal
